import { useContext } from "react";
import useLocales from "src/hooks/useLocales";
import TextInputField from "src/pages/Link/Products/Common/TextInputField";

import Context from "../../../../../context";
import { PositionSelection } from "../../../../../store";

// ----------------------------------------------------------------------
type Props = {
	id: string;
	onChangeShares: (value: string) => void;
};

export const CustomValueInput = ({ id, onChangeShares }: Props) => {
	const { actions, state } = useContext(Context);
	const { translate } = useLocales();

	const onChange = (value: string) => {
		const newPositionSelected: PositionSelection = {
			id,
			shares: value ? parseFloat(value) : null
		};
		const positions = state.selectedPositions.filter((i) => i.id !== id);
		actions.onChangeSelectedPositions([...positions, newPositionSelected]);
		onChangeShares(value);
	};

	return (
		<TextInputField
			name='shares'
			label={translate("Part. a traspasar")}
			type='number'
			onChange={onChange}
		/>
	);
};

export default CustomValueInput;
